<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >

                <v-text-field
                  v-model="form.Name"
                  label="名稱"
                  :rules="formRules.Name"
                ></v-text-field>

                <v-text-field
                  v-model="form.Sorting"
                  label="排序"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                  hint="排序數字越小，越前面"
                  :rules="formRules.Sorting"
                ></v-text-field>

                <v-select
                  :items="colorOptions"
                  item-text="Name"
                  item-value="ID"
                  label="顏色"
                  v-model="form.Color"
                ></v-select>

                <v-menu
                  v-model="beginDateMenu"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formattedBeginAt"
                      clearable
                      label="開始日期"
                      readonly
                      v-on="on"
                      :rules="formRules.BeginAt"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.BeginAt"
                    @change="beginDateMenu = false"
                  ></v-date-picker>
                </v-menu>

                <v-menu
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="formattedEndAt"
                      clearable
                      label="結束日期"
                      readonly
                      v-on="on"
                      :rules="formRules.EndAt"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="form.EndAt"
                    @change="endDateMenu = false"
                  ></v-date-picker>
                </v-menu>

              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    projectId: {
      type: Number,
      required: true,
      default: -1
    },
    task: {}
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    form: {},
    defaultForm: {Color:'#f75c4c'},
    beginDateMenu: false,
    endDateMenu: false,
    // color
    colorOptions: [
      { ID: '#f75c4c', Name: "紅色" },
      { ID: 'black', Name: "黑色" },
      { ID: 'yellow', Name: "黃色" },
      { ID: 'blue', Name: "藍色" },
      { ID: 'purple', Name: "紫色" }
    ]
  }),
  computed: {
    formRules() {
      return {
        BeginAt: [v => !!v || "請選擇開始時間"],
        EndAt: [v => !!v || "請選擇結束時間"],
        Name: [v => !!v || "請輸入名稱"],
        amount: [
          v => !!v || "請輸入排序",
          v => parseInt(v) <= 1000000000 || "排序不可超過10億"
        ]
      };
    },
    formTitle() {
      return this.task == null ? "新增" : "編輯";
    },
    formattedBeginAt() {
      return this.form.BeginAt ? moment(this.form.BeginAt).format("L") : "";
    },
    formattedEndAt() {
      return this.form.EndAt ? moment(this.form.EndAt).format("L") : "";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    project() {
      return this.$store.state.project.list.find(o => o.ID == this.projectId);
    }
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      if (this.task == null) this.form.ProjectID = this.projectId;

      if (moment(this.form.EndAt) <= moment(this.form.BeginAt))
        return alert("錯誤: 結束時間必須大於開始時間");

      let payload = JSON.parse(JSON.stringify(this.form));
      payload.BeginAt = moment(payload.BeginAt).toISOString(true);
      payload.EndAt = moment(payload.EndAt).toISOString(true);
      payload.Sorting = parseInt(payload.Sorting)

      this.isLoading = true;
      if (this.task == null) {
        this.$services.projectGanttTaskService
          .add(this, payload)
          .then(res => {
            this.$emit("changed", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.projectGanttTaskService
          .edit(this, payload)
          .then(res => {
            this.$emit("changed", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      var form = {}
      if (this.task) {
        form = JSON.parse(JSON.stringify(this.task));
      } else {
        form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if(form.BeginAt)form.BeginAt = moment(form.BeginAt).format("YYYY-MM-DD")
      if(form.EndAt)form.EndAt = moment(form.EndAt).format("YYYY-MM-DD")
      this.form = form
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>